import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import {
  Image,
} from '@uncinc/uncinc-react-kitchen-sink';

import {
  CoreLink,
} from '@uncinc/react-drupal-core';

import { DEFAULT_LANGUAGE } from '../../../../config/constants';

import './style.scss';

const NodeProductTeaser = ({ entity }) => {
  const { t } = useTranslation();
  const title = entity.getIn(['title', 0, 'value']);
  const imgSrc = entity.getIn(['field_media', 0, 'styles', 'cropped_small_4_3']);
  const imgAlt = entity.getIn(['field_media', 0, 'alt']);
  const currentLanguage = useSelector((state) => state.getIn(['ui', 'language'], DEFAULT_LANGUAGE));
  const path = entity.getIn(['paths', currentLanguage]);

  const isLogisticTool = entity.getIn(['field_logistics_tool', 0, 'value'], false);
  const isContributionObligation = entity.getIn(['field_contribution_obligation', 0, 'value'], false);
  const isPackageSpecial = entity.getIn(['field_special_packaging', 0, 'value'], false);

  return (
    <div className="NodeProductTeaser">
      <div className="NodeProductTeaser__content">
        <CoreLink to={path} className="NodeProductTeaser__title">
          <h2>{title}</h2>
        </CoreLink>
        <div className="NodeProductTeaser__properties">
          <div><i className={`icon ${isContributionObligation ? 'icon-checkmark' : 'icon-cross'}`} />{ t('product.teaser.isContributionObligation') }</div>
          <div><i className={`icon ${isLogisticTool ? 'icon-checkmark' : 'icon-cross'}`} />{ t('product.teaser.isLogisticTool') }</div>
          <div><i className={`icon ${isPackageSpecial ? 'icon-checkmark' : 'icon-cross'}`} />{t('product.teaser.isPackageSpecial') }</div>
        </div>
      </div>

      <div className="NodeProductTeaser__image_wrapper">
        <Image
          lazyload={false}
          className="NodeProductTeaser__image"
          src={imgSrc}
          alt={imgAlt}
        />
      </div>
    </div>
  );
};

export default NodeProductTeaser;
